import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

import { configureStore } from '@reduxjs/toolkit';

import { identityApi, lockersApi, receivedDigitalApi } from './api';
import appReducer from './slices/app';
import authReducer from './slices/auth';
import mailpieceActionReducer from './slices/mailpieceAction';
import pieceSearchReducer from './slices/piceSearch';
import recipientFilterReducer from './slices/recipientFilter';

const store = configureStore({
  reducer: {
    auth: authReducer,
    pieceSearch: pieceSearchReducer,
    app: appReducer,
    mailpieceAction: mailpieceActionReducer,
    recipientFilter: recipientFilterReducer,
    [receivedDigitalApi.reducerPath]: receivedDigitalApi.reducer,
    [lockersApi.reducerPath]: lockersApi.reducer,
    [identityApi.reducerPath]: identityApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      receivedDigitalApi.middleware,
      lockersApi.middleware,
      identityApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

// TODO: Move this out to a separate 'hooks.tsx' file
// to avoid potential circular import dependency issues.
const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
const useDispatch = () => useReduxDispatch<AppDispatch>();

export { store, dispatch, useSelector, useDispatch };
